import {ChangeDetectionStrategy, Component, Inject, Input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {TruncatePipeModule} from "@atlas-workspace/shared/pipes";
import {WEB_PLATFORM_TYPE} from "@atlas-workspace/shared/translate";
import {EPlatform} from "@atlas-workspace/shared/models";
import {CommonModule, NgClass} from "@angular/common";

@Component({
  selector: 'atl-search-result',
  template: `
    <img class="wl-icon-filter" [width]="iconSize" [height]="iconSize" [src]="noResult.icon" alt="icon"/>
    <h2 class="title" [class.threads]="threads">{{ noResult.title | translate }}</h2>
    <p
      *ngIf="searchParam"
      class="description"
      [ngClass]="{threads, 'text-black-810': !isClient}"
    >
      {{ noResult.description | translate }} "{{ searchParam | truncate: truncateLimit }}"
    </p>
  `,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    .title {
      font-size: 20px;
      line-height: 24px;
      font-weight: 500;
      margin-top: 16px;

      &.threads {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .description {
      font-size: 16px;
      line-height: 24px;
      margin-top: 8px;
      text-align: center;

      &.threads {
        font-size: 14px;
        line-height: 24px;
        margin-top: 0;
      }
    }
  `],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    TruncatePipeModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoSearchResultComponent {
  @Input() searchParam?: string = '';
  @Input() iconSize!: number;
  @Input() truncateLimit = 40;
  @Input() threads = false;

  public readonly noResult = {
    icon: '',
    title: 'Shared.No_results',
    description: 'Shared.No_search_result',
  };
  public isClient = false;

  constructor(@Inject(WEB_PLATFORM_TYPE) public platform: EPlatform) {
    this.isClient = platform === EPlatform.WEB_CLIENT;
    this.noResult.icon = this.isClient ? '/assets/glass-bl-no-result.svg' : 'assets/glass-no-result.svg';
  }
}
